import React, { Component } from 'react';
import {Link, browserHistory } from 'react-router';
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';

export default class SmartCart extends Component{
	constructor(props){
		super(props);
		this.state={
			cartcount:'',
			page_loading:false,
			smart_filters:[],
			smart_deals:[],
			active_filter:0,

			//  add to cart values
			replace_did:'',
			replace_deal_type:'',
			replace_qty:'',
			replace_pl_size:'',
			replace_salinity:'',
			replace_pickup_date:'',
			replace_id:'',
			replace_product_name:'',

			cart_status:false,
			cart_status_msg:'',
			clearcart_status:false,
			cart_added_status:false,
			// cart values ends here
		}
		this.getSmartFilters=this.getSmartFilters.bind(this);
		this.getSmartDeals=this.getSmartDeals.bind(this);
		this.getSmartDealsByType=this.getSmartDealsByType.bind(this);
		this.addToCart=this.addToCart.bind(this);
		this.close=this.close.bind(this);
		this.replaceCartItems=this.replaceCartItems.bind(this);
		this.getCartCount=this.getCartCount.bind(this);
		this.tokenCheck=this.tokenCheck.bind(this);
	}
	componentDidMount()
	{
		if(!localStorage.token && !localStorage.user_id)
		{
			localStorage.setItem('smartcart','/smartcart');
			browserHistory.push('/login');
		}
		else
		{
			this.getCartCount();
			this.getSmartFilters();
			this.getSmartDeals();
		}
	}
	tokenCheck()
	{
		localStorage.removeItem('user_id');
		localStorage.removeItem('token');
		window.location.reload();
	}
	getSmartFilters()
	{
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'mobile_web',id:localStorage.user_id,token:localStorage.token};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'smart_list_filters',
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						smart_filters:data.filters,
					});
				}
				if(data.status==='error' && data.message==='Token mismatch')
				{
					this.tokenCheck();
				}
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	getSmartDeals()
	{
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'mobile_web',id:localStorage.user_id,token:localStorage.token,dtype:0};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'smart_list',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						smart_deals:data.data,
					});
				}
				if(data.status==='error' && data.message==='Token mismatch')
				{
					this.tokenCheck();
				}
			}.bind(this),
			error:function(err)
			{
			}
		});
	}
	getSmartDealsByType(dtype)
	{
		this.setState({
			active_filter:dtype,
		});
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'mobile_web',id:localStorage.user_id,token:localStorage.token,dtype:dtype}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'smart_list',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						smart_deals:data.data,
					});
				}
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	// data.did,data.dtype,data.qty,data.pl,data.salinity,data.pickup_date,data.id,data.product_name
	addToCart(did,deal_type,qty,pl,salinity,pickup_date,id,product_name)
	{
		this.setState({
			replace_did:did,
			replace_deal_type:deal_type,
			replace_qty:qty,
			replace_pl_size:pl,
			replace_salinity:salinity,
			replace_pickup_date:pickup_date,
			replace_id:id,
			replace_product_name:product_name,
		});
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'mobile_web',id:localStorage.user_id,token:localStorage.token,deal_id:did,deal_type:deal_type,quantity:qty,pl_size:pl,salinity:salinity,pickup_date:pickup_date}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'addToCart',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==="success" && data.message==="Added to cart")
				{
					// this.setState({
					// 	cart_status:true,
					// 	cart_status_msg:data.message,
					// });
					browserHistory.push('/mycart');
				}
				if(data.status==="success" && data.message==="Cart Updated")
				{
					this.setState({
						cart_status:true,
						cart_status_msg:data.message,
					});
				}
				if(data.status==="error"  && data.cart_flag===0)
				{
					this.setState({
						clearcart_status:true,
					});
				}
				if(data.status==="error" && data.message==="Product already added to the cart" && data.cart_flag ===1)
				{
					this.setState({
						cart_added_status:true,
					});
				}
				this.getCartCount();
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	replaceCartItems()
  	{
  		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from: 'mobile_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),deal_id:this.state.replace_did,deal_type:this.state.replace_deal_type,quantity:this.state.replace_qty,pl_size:this.state.replace_pl,salinity:this.state.replace_salinity,pickup_date:this.state.replace_pickup_date}
	    var data2=JSON.stringify(data1);
	    $.ajax({
			method:'post',
			dataType:'json',
			url: baseUrl+'replaceCart',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==="success" && data.cart_flag===1)
				{
					// this.setState({
					// 	clearcart_status:false,
					// 	cart_status:true,
					// 	cart_status_msg:data.message,
					// });
					browserHistory.push('/mycart');
				}
				else
				{
					this.getCartCount();
				}
			}.bind(this),
			error:function(err)
			{
			}
		});
  	}
	close()
	{
		this.setState({
			cart_status:false,
			clearcart_status:false,
			cart_added_status:false,
		})
	}
	getCartCount()
  	{
     	var baseUrl='https://aquadeals.in/admin/web3/user/';
      	var data1={from:'mobile_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token')};
      	var data2=JSON.stringify(data1);
      	$.ajax({
            method: 'POST',
            url: baseUrl+'cart_count',
            dataType:'json',
            data: {req:data2},
            success: function(data)
            {
	            if(data.status==='success')
	            {
	             	this.setState({
	                  cartcount:data.cart_count,
	              	});	
	            }
	            else if(data.status==='error' && data.message==='Token mismatch')
	            {
	             	localStorage.clear();
	    			window.location.reload();
	            }
            }.bind(this),
            error: function(err)
            {
            
            }
	    });
	}
	render(){
		document.title="Smart Cart | AquaDeals";
		var smart_filters = this.state.smart_filters.map(function(data,index){
			return(
				<a className={this.state.active_filter === data.id ? "smt_fltr_item smt_fltr_item_active" : "smt_fltr_item"} onClick={()=>{this.getSmartDealsByType(data.id)}}>{data.name}{this.state.active_filter === data.id ? <i className="smt_arrow"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/triangle_up.png'} alt=" " style={{width:'20px',height:'18px'}} /></i> : ''}</a>

			)
		}.bind(this));
		var smart_deals=this.state.smart_deals.map(function(data,index){
			return(
				<div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 smt_dtls_item">
					<Link to={data.type === 0 ? "/sdetails/"+data.sname+"/"+data.did : "/pdetails/"+data.url_dtype_name+"/"+data.url_cat_name+"/"+data.url_brand_name+"/"+data.url_product_name+"/"+data.pid+"/"+data.id}>
						<div className="smt_img_blk">
							<i><img src={data.img} alt="" /></i>
						</div>
						<div className="smt_data_blk">
							{data.product_name ? <h5 className="smt_pro_name">{data.product_name}</h5> : <h5 className="smt_pro_name">&nbsp;</h5>}
							{data.brand_name ? <h6 className="smt_pro_brand">{data.brand_name}</h6> : <h6 className="smt_pro_brand">&nbsp;</h6>}
							{data.mrp ? <p className="smt_pro_price">MRP : &#8377; {data.mrp}</p> : <p className="smt_pro_price">&nbsp;</p>}
							{data.date ? <p className="smt_pro_date">Date : {data.date}</p> : <p>&nbsp;</p>}
						</div>
					</Link>
					{data.cart_flag===1 ? <div className="smt_add_blk"><a className="smt_add_cart_btn" href="/mycart">GO TO CART</a></div> : <div className="smt_add_blk"><a className="smt_add_cart_btn" onClick={()=>{this.addToCart(data.did,data.type,data.qty,data.pl,data.salinity,data.pickup_date,data.id,data.product_name)}}>ADD TO CART</a></div>}
				</div>
			);
		}.bind(this))
		return(
			<div className="mob_deals mob_smartcart">
				<div className="page_hdr">
				    {this.state.cartcount !==0 ? 
				      	<div className="container-fluid">
				      		<h5><Link to={'/'}><i><img className="cross_icon" src={'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png'} width="14px" alt=""/></i></Link> SMART CART</h5>
					        <a href="/" className="home_newicon"><img src={'https://aquadeals.in/admin/assets/images/web_imgs/home1.png'} alt="Home" /></a>
					        <a className="mob_smart_cart_btn" href="/mycart">
								<img alt="" src={'https://aquadeals.in/admin/assets/icons/web_icons/cart_icon.png'} />
								{this.state.cartcount > 0 ? <span className={"mob_cart_count1"}>{this.state.cart_count > 9 ? <span>{this.state.cartcount}</span> : <span>&nbsp;{this.state.cartcount}&nbsp;</span>}</span> : ''}
							</a>
					    </div>
					:  
					    <div className="container-fluid">
					        <h5><Link onClick={()=>{browserHistory.goBack()}}><i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png'} width="16px" alt=""/></i></Link> Smart Cart</h5>
					        <a href="/" className="home_logo_cart"><img src={'https://aquadeals.in/admin/assets/images/web_imgs/home1.png'} alt="Home" /></a>
					    </div>
					}
				</div>
				<div className="clr">&nbsp;</div>
			    <div className="clr">&nbsp;</div>
			    <div className="clr">&nbsp;</div>
			    {smart_filters.length > 0 ?
			    	<div className="">
			    		{this.state.page_loading ? <div className="checkout_loading"><img src={'https://aquadeals.in/admin/assets/images/loading_more.gif'} alt="Loading"  /></div> :
			    			<div>
				    			<div className="smt_fltrs_blk">
				    				<div>
				    					{smart_filters}
				    				</div>
				    			</div>
				    			<div className="smt_deals_blk">
				    				{smart_deals.length > 0 ? smart_deals : <div className="no_data">No Previous Orders Found</div>}
				    			</div>
			    			</div>
			    		}
			    		<Modal className="m_pro_full_dtls_modal"  show={this.state.cart_status} onHide={this.close}  >
							<Modal.Header closeButton>
					    		<Modal.Title style={{fontSize:'16px',color:'#333'}}>Alert</Modal.Title>
					  		</Modal.Header>
					  		<Modal.Body>
					  			<h4 style={{fontSize:'14px',color:'#666'}}>{this.state.cart_status_msg}</h4>
					  		</Modal.Body>
					  		<Modal.Footer className="modal_footer">
						  		<Button style={{background: 'none',border:'none',color:'#ff742a'}} onClick={this.close}>Close</Button>
						  	</Modal.Footer>
					  	</Modal>
					  	<Modal className="m_pro_full_dtls_modal"  show={this.state.clearcart_status} onHide={this.close}  >
							<Modal.Header closeButton>
					    		<Modal.Title style={{fontSize: '16px',color:'#333'}}>Alert</Modal.Title>
					  		</Modal.Header>
					  		<Modal.Body>
					  			<h4 style={{fontSize:'14px', color:'#333'}}>You can't have multiple seller items in the cart. Empty existing cart & add this item {this.state.replace_pro_title}?</h4>
					  		</Modal.Body>
					  		<Modal.Footer className="modal_footer">
				  				<Button style={{background: 'none',border:'none',color:'#ff742a'}} onClick={this.close}>NO</Button>
				  				<a><Button style={{background:'none',border:'none',color: '#ff742a'}} onClick={()=>{this.replaceCartItems()}}>YES</Button></a>
					  		</Modal.Footer>
						</Modal>
						<Modal className="m_pro_full_dtls_modal"  show={this.state.cart_added_status} onHide={this.close}  >
							<Modal.Header closeButton>
					    		<Modal.Title style={{fontSize:'16px',color:'#333'}}>Alert</Modal.Title>
					  		</Modal.Header>
					  		<Modal.Body>
					  			<h4 style={{fontSize:'14px',color:'#666'}}>Product already added to the cart!</h4>
					  		</Modal.Body>
					  		<Modal.Footer className="modal_footer">
						  		<Button style={{background: 'none',border:'none',color:'#ff742a'}} onClick={this.close}>Close</Button>
						  	</Modal.Footer>
					  	</Modal>
			    	</div> : <div className="no_data">No Previous Orders Found</div>
			    }
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Categories/SmartCart/SmartCart.js
 **/